import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Extended tailwind-merge config.
 *
 * Without this, tailwind-merge sees both `text-body-md` (our custom font-size)
 * and `text-primary-foreground` (a color) as "text-*" classes and keeps only
 * the last one — silently dropping the text color from every Button variant
 * and making primary/destructive/secondary buttons invisible.
 *
 * Registering our custom text-* font-size tokens here tells tailwind-merge
 * they're a different group so color + size can coexist.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'display-xl',
            'display-lg',
            'display-md',
            'heading-xl',
            'heading-lg',
            'heading-md',
            'heading-sm',
            'body-lg',
            'body-md',
            'body-sm',
            'caption',
            'overline',
            'code',
          ],
        },
      ],
    },
  },
})

/**
 * Compose Tailwind class lists safely: clsx handles conditionals,
 * extended tailwind-merge deduplicates conflicting utilities (later wins)
 * while preserving our custom font-size + color separation.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
